"use client";

import { useState, useEffect } from "react";
import { Building, Mail, Globe, Briefcase, Edit, Eye } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BackButton from "../shared/backButton";
import "./OrganizationDetailPage.css";
import { getOnboardedOrganizationByIdApi } from "../../services/settingsService";
import { getBrandsAccess } from "../shared/access.js";
const OrganizationDetailPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [organization, setOrganization] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const hasBrandsAccess = getBrandsAccess();
  const contactAdminTooltip = t("common.permissions.contactAdminForAction");
  useEffect(() => {
    getOnboardedOrganizationByIdApiHandler();
  }, []);

  const checkSwitchDisabled = () => {
    return sessionStorage.getItem("email") == organization.createdBy;
  };

  const handleOrgView = async () => {
    console.log("View organization details", organization);
    sessionStorage.setItem("tenantId", organization.clientTenantId);
    sessionStorage.setItem("orgCode", organization.clientOrgCode);
    sessionStorage.setItem("organization", organization.clientOrganization);
    sessionStorage.setItem("selectedTenantId", organization.clientTenantId);
    sessionStorage.setItem("selectedOrgCode", organization.clientOrgCode);
    sessionStorage.setItem(
      "selectedOrganization",
      organization.clientOrganization,
    );
    navigate("/home");
  };
  const getOnboardedOrganizationByIdApiHandler = async () => {
    setIsLoading(true);
    try {
      const response = await getOnboardedOrganizationByIdApi(id);
      if (response.code === 200) {
        setOrganization(response.data);
      }
    } catch (error) {
      console.error("Error loading organization:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/brand");
  };

  const handleEdit = () => {
    navigate(`/brand/edit/${id}`);
  };

  if (isLoading) {
    return (
      <div className="org-detail-page">
        <main className="org-detail-main">
          <div className="container">
            <div className="org-detail-loading">{t("common.loading")}</div>
          </div>
        </main>
      </div>
    );
  }

  if (!organization) {
    return (
      <div className="org-detail-page">
        <main className="org-detail-main">
          <div className="container">
            <div className="org-detail-error">
              {t("organizationDetail.organizationNotFound")}
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="org-detail-page">
      <main className="org-detail-main">
        <div className="container">
          <div className="org-detail-header">
            <BackButton />

            <div className="org-detail-actions " style={{ width: "100%" }}>
              <span
                title={!hasBrandsAccess.canEditBrand ? contactAdminTooltip : ""}
                style={{ float: "right", display: "inline-block" }}
              >
                <button
                  disabled={
                    !checkSwitchDisabled() && hasBrandsAccess.canEditBrand
                  }
                  disabled={!hasBrandsAccess.canEditBrand}
                  className="org-detail-edit-btn"
                  onClick={handleEdit}
                  style={{ float: "right" }}
                >
                  <Edit size={16} />
                  {t("organizationDetail.editOrganization")}
                </button>
              </span>

              <span
                title={!checkSwitchDisabled() ? contactAdminTooltip : ""}
                style={{
                  float: "right",
                  marginRight: "10px",
                  display: "inline-block",
                }}
              >
                <button
                  disabled={!checkSwitchDisabled()}
                  className="org-detail-edit-btn"
                  onClick={handleOrgView}
                  style={{ float: "right", marginRight: "10px" }}
                >
                  <Eye size={16} />
                  {t("organizationDetail.view")}
                </button>
              </span>
            </div>
          </div>

          <div className="org-detail-content">
            <div className="org-detail-hero">
              <div className="org-detail-avatar">
                <Building size={48} />
              </div>
              <div className="org-detail-info">
                <h1>{organization.clientOrganization}</h1>
                {organization.clientIndustry && (
                  <p className="org-detail-industry">
                    {organization.clientIndustry}
                  </p>
                )}
              </div>
            </div>

            <div className="org-detail-grid">
              <div className="org-detail-card">
                <h3>{t("organizationDetail.contactInformation")}</h3>
                <div className="org-detail-field">
                  <Mail size={16} />
                  <div>
                    <label>{t("organizationDetail.AdminName")}</label>
                    <span>{organization.clientName}</span>
                  </div>
                </div>
                <div className="org-detail-field">
                  <Mail size={16} />
                  <div>
                    <label>{t("organizationDetail.email")}</label>
                    <span>{organization.clientEmail}</span>
                  </div>
                </div>
                {/* <h3>{t("organizationDetail.AdminName")}</h3> */}

                <div className="org-detail-field">
                  <Globe size={16} />
                  <div>
                    <label>{t("organizationDetail.website")}</label>
                    <a
                      href={organization.clientWebsite}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {organization.clientWebsite}
                    </a>
                  </div>
                </div>
              </div>

              <div className="org-detail-card">
                <h3>{t("organizationDetail.organizationDetails")}</h3>
                <div className="org-detail-field">
                  <Briefcase size={16} />
                  <div>
                    <label>{t("organizationInfo.industry")}</label>
                    <span>
                      {organization.clientIndustry
                        ? organization.clientIndustry
                        : t("organizationDetail.industryNotSpecified")}
                    </span>
                  </div>
                </div>

                <div className="org-detail-field">
                  <Briefcase size={16} />
                  <div>
                    <label>{t("organizationInfo.status")}</label>
                    <span>
                      {organization.clientStatus
                        ? organization.clientStatus
                        : t("organizationDetail.statusNotSpecified")}
                    </span>
                  </div>
                </div>
                <div className="org-detail-field">
                  <Briefcase size={16} />
                  <div>
                    <label>{t("organizationInfo.StartDate")}</label>
                    <span>
                      {organization.createdAt
                        ? new Date(organization.createdAt).toLocaleDateString()
                        : "-"}
                    </span>
                  </div>
                </div>

                <div className="org-detail-field">
                  <Briefcase size={16} />
                  <div>
                    <label>{t("organizationInfo.DueDate")}</label>
                    <span>
                      {organization.clientDueDate
                        ? new Date(
                            organization.clientDueDate,
                          ).toLocaleDateString()
                        : "-"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default OrganizationDetailPage;
